(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  (() => {
    const selector = '[data-fs-cart-note]';

    const bindCartNote = () => {
      document.querySelectorAll(selector).forEach((textarea) => {
        if (textarea.dataset.fsCartNoteBound === 'true') return;
        textarea.dataset.fsCartNoteBound = 'true';

        const status = textarea.parentElement?.querySelector('[data-fs-cart-note-status]');
        let timer;

        const saveNote = async () => {
          if (status) status.textContent = 'Saving...';

          try {
            const root = window.Shopify?.routes?.root || '/';
            const response = await fetch(`${root}cart/update.js`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({ note: textarea.value })
            });

            if (!response.ok) throw new Error('Unable to save cart note');

            if (status) {
              status.textContent = 'Saved';
              setTimeout(() => {
                if (status.textContent === 'Saved') status.textContent = '';
              }, 1800);
            }
          } catch (error) {
            if (status) status.textContent = 'Could not save note. Please try again.';
            console.error('[FS Cart Note]', error);
          }
        };

        textarea.addEventListener('input', () => {
          clearTimeout(timer);
          timer = setTimeout(saveNote, 700);
        });

        textarea.addEventListener('blur', () => {
          clearTimeout(timer);
          saveNote();
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bindCartNote, { once: true });
    } else {
      bindCartNote();
    }

    new MutationObserver(bindCartNote).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
  /*
   * The search page's own search form in this theme can submit without a
   * resource type. Force normal page searches to include both products
   * and blog articles, matching the predictive-search modal.
   */
  const ensureSearchTypes = () => {
    document.querySelectorAll('form').forEach((form) => {
      const queryInput = form.querySelector('input[name="q"][type="search"], input[name="q"]');
      if (!queryInput) return;

      let action;
      try {
        action = new URL(form.action || window.location.href, window.location.origin);
      } catch {
        return;
      }

      if (!action.pathname.endsWith('/search')) return;

      let typeInput = form.querySelector('input[name="type"]');
      if (!typeInput) {
        typeInput = document.createElement('input');
        typeInput.type = 'hidden';
        typeInput.name = 'type';
        form.appendChild(typeInput);
      }

      typeInput.value = 'product,article';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureSearchTypes, { once: true });
  } else {
    ensureSearchTypes();
  }

  } catch(e) { console.error(e); }
})();
})();
